/**
 * App URLs and defaults for development.
 * Override for production via `.env` (must prefix with `REACT_APP_` for Create React App).
 *
 * - `REACT_APP_API_URL` — HIVEAIASSURE FastAPI backend (axios base URL).
 * - `REACT_APP_SAMPLE_DATABASE_URL` — Optional placeholder for Application Settings UI (not connected to runtime).
 */
const trimTrailingSlash = (url: string) => url.replace(/\/+$/, '');

function envUrl(envKey: string, devDefault: string): string {
  const v = process.env[envKey];
  const raw = v != null && String(v).trim() !== '' ? String(v).trim() : devDefault;
  return trimTrailingSlash(raw);
}

/** Plain string from env (no slash trim) — e.g. JDBC-style URLs. */
function envRaw(envKey: string, devDefault: string): string {
  const v = process.env[envKey];
  return v != null && String(v).trim() !== '' ? String(v).trim() : devDefault;
}

export const config = {
  apiBaseUrl: envUrl('REACT_APP_API_URL', 'http://localhost:8001'),
  /** Placeholder for admin UI database field (not wired to backend). */
  sampleDatabaseUrl: envRaw(
    'REACT_APP_SAMPLE_DATABASE_URL',
    'mysql://localhost:3306/testgenai'
  ),
} as const;
